export default "__VITE_ASSET__CgYDvPva__"